/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Answerallquestions2Inputs */

const en_questionnaire_answerallquestions2 = /** @type {(inputs: Questionnaire_Answerallquestions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please answer all questions`)
};

const fr_questionnaire_answerallquestions2 = /** @type {(inputs: Questionnaire_Answerallquestions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez répondre à toutes les questions`)
};

/**
* | output |
* | --- |
* | "Please answer all questions" |
*
* @param {Questionnaire_Answerallquestions2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_answerallquestions2 = /** @type {((inputs?: Questionnaire_Answerallquestions2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Answerallquestions2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_answerallquestions2(inputs)
	return fr_questionnaire_answerallquestions2(inputs)
});
export { questionnaire_answerallquestions2 as "questionnaire_answerAllQuestions" }